module.exports = {
    visualization: "Visualization",
    analytics: "Analytics",
    profile: "Profile",
    dashboard: "Dashboard",
    realtime: "Realtime",
    voltage: "Voltage",
    current: "Current",
    active_power: "Active power",
    reactive_power: "Reactive power",
    apparent_power: "Apparent power",
    energy_export: "Energy export",
    energy_import: "Energy import",
    hourly_active_report: "Hourly active report",
    daily_active_report: "Daily active report",
    monthly_active_report: "Monthly active report",
    daily_reactive_report: "Daily reactive report",
    language_change: "Localization",
    disaggregation: "Disaggregation",
    appliances_imprints: "Appliances imprints",
    appliances_energy: "Appliances energy",
    appliances_timeline: "Appliances timeline",
    appliances_run_profile: "Appliances run profile",
    imprints_map: "Imprints map",
    logout: "Logout",
    logout_mini: "L",
    edit_profile: "Edit Profile",
    edit_profile_mini: "EP",
    monitoring: "Monitoring",
    tools: "Tools",
    manual_learning: "Manual learn",
    settings: "Settings",
    disconnector_timeline: "Timeline",
    energy_profile: "Energy profile",
    power_factor: "Power factor",
    test_profile: "Test profile",
    quarter_hour_active_report: "Quarter hour active report",
    testing_process: "Testing process",
    tests_results: "Tests results",
    integration: "Integration",
    quarter_hour_maximum_active_report: "Maximum in 15 minutes",
    reactive_energy: "Reactive energy",
    state: "State",
    rising_shapes: "Rising shapes",
    falling_shapes: "Falling shapes",
    firmware_upgrade: "Firmware upgrade",
    control_map: "Control map",
    notifications: "Notifications",
    anomaly_models: "Anomaly models",
    df_voltage: "Distortion Factor of Voltage",
    df_current: "Distortion Factor of Current",
    frequency: "Frequency",
    apparent_energy: "Apparent energy",
    vector_diagram: "Vector diagram",
    harmonics_chart: "Harmonics chart",
    waveform_chart: "Waveform chart"
}